export default {
  selectable: false,
};
